var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashDanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 4H3.33333H14",
    stroke: "#FF5555",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4168 4.00004C13.4168 3.58583 13.081 3.25004 12.6668 3.25004C12.2526 3.25004 11.9168 3.58583 11.9168 4.00004H13.4168ZM4.0835 4.00004C4.0835 3.58583 3.74771 3.25004 3.3335 3.25004C2.91928 3.25004 2.5835 3.58583 2.5835 4.00004H4.0835ZM4.5835 4.00004C4.5835 4.41425 4.91928 4.75004 5.3335 4.75004C5.74771 4.75004 6.0835 4.41425 6.0835 4.00004H4.5835ZM9.91683 4.00004C9.91683 4.41425 10.2526 4.75004 10.6668 4.75004C11.081 4.75004 11.4168 4.41425 11.4168 4.00004H9.91683ZM11.9168 4.00004V13.3334H13.4168V4.00004H11.9168ZM11.9168 13.3334C11.9168 13.6555 11.6557 13.9167 11.3335 13.9167V15.4167C12.4841 15.4167 13.4168 14.484 13.4168 13.3334H11.9168ZM11.3335 13.9167H4.66683V15.4167H11.3335V13.9167ZM4.66683 13.9167C4.34466 13.9167 4.0835 13.6555 4.0835 13.3334H2.5835C2.5835 14.484 3.51624 15.4167 4.66683 15.4167V13.9167ZM4.0835 13.3334V4.00004H2.5835V13.3334H4.0835ZM6.0835 4.00004V2.66671H4.5835V4.00004H6.0835ZM6.0835 2.66671C6.0835 2.34454 6.34466 2.08337 6.66683 2.08337V0.583374C5.51624 0.583374 4.5835 1.51611 4.5835 2.66671H6.0835ZM6.66683 2.08337H9.3335V0.583374H6.66683V2.08337ZM9.3335 2.08337C9.65566 2.08337 9.91683 2.34454 9.91683 2.66671H11.4168C11.4168 1.51611 10.4841 0.583374 9.3335 0.583374V2.08337ZM9.91683 2.66671V4.00004H11.4168V2.66671H9.91683Z",
    fill: "#FF5555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashDanger);
export default __webpack_public_path__ + "static/media/trash-danger.2ddb0a2b6d0c07dadd9a980bcb9f237c.svg";
export { ForwardRef as ReactComponent };